import React, {useEffect, useState} from "react"
import {ReturnTextAndImg} from "../CheckImg"

export default function OrderAnswer({data, changeOrderAnswer, isPassed, userAnswers}) {
  const [currentItem, setCurrentItem] = useState({});
 
  let answers = isPassed && userAnswers.value;
  let isError = false;
  let style = {
    right: {
      border: '3px solid rgba(128, 253, 195, 0.76)',
    },
    wrongUser: {
      border: '3px solid rgba(253, 128, 128, 0.76)',
    },
  }

  function shuffle(arr) {
    let array = arr.slice()
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array
  }

  let actionsData = shuffle(data).map((item,i) => {
    return {
      id: i+1,
      name: item,
    }
  })
  const [actions, setActions] = useState(actionsData);
  function changeColor(e, color) {
    if(e.target.localName === "div") {
      e.target.style.background=color 
    }
  }

  useEffect(() => {
    changeOrderAnswer(actions.map(item => item.name))
  }, [actions])

  function dragStart(e, item) {
    setCurrentItem(item)
  }

  function dragOver(e) {
    e.preventDefault()
    changeColor(e, "lightgrey")
  }

  function dragLeave(e) {
    changeColor(e, "white")
  }

  function dragEnd(e) {

  }

  function dragDrop(e, dropItem) {   

    changeColor(e, "white")

    let result = actions.map(item => {
      if(item.id === currentItem.id) {
        return {...item, id: dropItem.id}
      }
      if (item.id > currentItem.id && item.id <= dropItem.id) {
        return {...item, id: item.id-1}
      }
      if(item.id < currentItem.id && item.id >= dropItem.id) {
        return {...item, id: item.id+1}
      }
      return item;
    });

    setActions(result)  
  }
  
  const sortList = (a,b) => {
    if (a.id > b.id) {
      return 1
    } else {return -1}
  }

  let sortDataResult = actions.sort(sortList).map((item,i) => {
    isError = (isPassed && answers[i] !== data[i]) || isError
    let itemStyle = isPassed && !isError && answers[i] === data[i] ? style.right : isPassed ? style.wrongUser : null
    const text = ReturnTextAndImg(item.name);
    return <div style={itemStyle}
    // data-keen-slider-clickable
              className="order-question-item" 
              key={`gggq${item.name}`}
              draggable={!isPassed}
              onDragStart={(e) => dragStart(e, item)}
              onDragLeave={(e) => dragLeave(e)}
              onDragOver={(e) => dragOver(e)}
              onDragEnd={(e) => dragEnd(e)}
              onDrop={(e) => dragDrop(e, item)} 
                                  >{text}</div> })

  return (
    <div className="order-question-container" >
      {sortDataResult}
    </div>
  )
}